import { Injectable } from '@angular/core';
import { wfBusinessProcessStateDataGridAction } from '../business-process-management/ChildComponents/BusinessProcessState/State.model';
import {SafeResourceUrl} from "@angular/platform-browser";

export class WorkFlowType {
  lwfBusinessProcessTypeId: number;
  wfBusinessProcessType1: string;
  DisplayOrder: number;
  Description: string;
}

export class BusinessProcessHTML {
  RowNumber: string;
  WorkflowType: string;
  lUserId: number;
  User: string;
  BusinessProcess: string;
  ItemCount: number;
  CountQuery: string;
  DataQuery: string;
  ConnString: string;
  IsOpenQuery: number;
}


export class BusinessProcessViewModel {
  WorkFlowType: WorkFlowType;
  BusinessProcesses: BusinessProcessHTML[];
  GetIsCountFetched: number;
}

export class BusinessProcessStateHTML {
  IdentityColumn: string;
  lwfBusinessProcessStateId: number;
  wfBusinessProcessState: string;
  lwfBusinessProcessDefinitionId: number;
  wfBusinessProcessDefinitionName: string;
  User: string;
  NoofQueues: number;
  StateWithNoofQueues: string;
  DisplayOrder: string;
  wfBusinessProcessStateDisplayName: string;
}

export class BusinessProcessDefinitionDetail {
  lwfBusinessProcessDefinitionId: number;
  wfBusinessProcessDefinition: string;
  lProcessStartUpRuleId: number;
  lwfBusinessProcessTypeId: number;
  Description: string;
  IsComments: number;
  IsEnabled: number;
  lwfBusinessProcessModelId: number;
  IsOwnerSpecificQueue: number;
  wfBusinessProcessRule: string;
  wfBusinessProcessModel: string;
  wfBusinessProcessType: string;
  ActionType: string;
  lwfBusinessProcessRuleActionId: number;
  wfBusinessProcessRuleAction: string;
  IsStateLessParentContainer: number;
}

export class BusinessProcessInstanceViewModel {
  DynamicColumns: ColumnNameWithDataType[];//FB38211-charles
  DynamicInstanceDataSource: string;
}

//FB38211-charles
export class ColumnNameWithDataType {
  ColumnName: string;
  DataType: string;
}

export class BusinessProcessInstanceCurrentStateData {

  lBusinessProcessInstanceCurrentStateDataId: string;
  lwfBusinessProcessInstanceId: number;
  lManualInitiationById: number;
  lwfBusinessProcessDefinitionId: number;
  wfBusinessProcessInstance: string;
  ProcessInitiatedOn: Date
  Comments: string;
  wfBusinessProcessDefinition: string;
  lwfBusinessProcessStateId: number;
  wfBusinessProcessState: string;
  lwfBusinessProcessStateDataId: number;
  StateEntryTime: Date
  StateExitTime: Date
  lwfBusinessProcessRuleActionId: number;
  PreviousState: string;
  sMessage: string;
  lUserId: number;
  PreviousStateUser: string;
  PreviousStateExitTime: any;
  DataCaption: string;
  DataType: string;
  lDataEntityFieldNameId: number;
  DataTypeParameter: string;
  ConditionType: string;
  Condition: string;
  DisplayOrder: number;
  IsMandatory: number;
  IsInstanceName: number;
  DataValue: any;
  lwfBusinessProcessInstanceStateDataId: number;
  IsVisible: number;
  IsEnabled: number;
  ItemSource: any;
  TextSize: number;
  DefaultValue: string;
  IsDataCaptionVisible: number;
  MultiSelectedItems: any[];
  DueDate: any;
  DueDateRule: any;
  FileDetail: any;
  ReferenceDataTextBoxVisible: number;
  ReferenceDataURLVisible: number;
  TabName: string;
  TabDisplayOrder: number;
  lwfBusinessProcessStateTypeId: number;
  FormatString: string;
  Min: number;
  Max: number;
  opened: boolean;
  Height: number;
  DisplayName: string;
  IsInboxDefaultColumnVisible: number;
  IsDisplayExit: number;
  IsStateDataReadOnly: number;
  IsStateDataEnabled: number;
  IsStateDataVisible: number;
  StateDataGridColumns: any;
  IsAddRowEnabled: number;
  IsAddRowViaPopup: number;
  IsDeleteRowEnabled: number;
  IsViewViaPopup: number;
  BusinessProcessStateGridDataQueryResult: BusinessProcessStateGridDataQueryResult[];
  BusinessProcessStateGridData: BusinessProcessStateGridData[];
  IsLinkEnabled: number;
  LinkURL: string;
  LinkName: string;
  GroupName: string;
  ControlState: string;
  PlaceHolder: string;
  ScoringModel: string;
  BasePeriod: string;
  Period: string;
  TradingCounterparty: string;
  QuantitativeControl: string;
  QualitativeControl: string;
  ScoreAnalysisControl: string;
  FinalScoreControl: string;
  PowerBIReport: string;
  AddTodayButton: any;
  IsCopyButtonEnabled: number;
  wfBusinessProcessStateDataGridActions: wfBusinessProcessStateDataGridAction[];
  IsHalfWidth: number;
  SafeUrl: SafeResourceUrl;
}

export class BusinessProcessStateAction {
  lBusinessProcessStateActionId: number;
  lwfBusinessProcessDefinitionId: number;
  wfBusinessProcessDefinition: string;
  lProcessStartUpRuleId: number;
  lwfBusinessProcessTypeId: number;
  Description: string;
  IsComments: number;
  IsEnabled: number;
  lwfBusinessProcessModelId: number;
  IsOwnerSpecificQueue: number;
  wfBusinessProcessModel: string;
  wfBusinessProcessType: string;
  lwfBusinessProcessStateId: number;
  wfBusinessProcessState: string;
  lwfBusinessProcessRuleId: number;
  wfBusinessProcessRule: string;
  lwfBusinessProcessRuleActionId: number;
  wfBusinessProcessRuleAction: string;
  ActionType: string;
  DisplayOrder: number;
  IsDisabled?: boolean;//FB48599-Pawan Prajapati
  DisabledMessage?: boolean;//FB48599-Pawan Prajapati
  IsSuccessAlert: number;
}

export class BusinessProcessStateActionExecute {
  lBusinessProcessStateActionExecuteId: number;
  lwfBusinessProcessDefinitionId: number;
  wfBusinessProcessDefinition: string;
  lProcessStartUpRuleId: number;
  lwfBusinessProcessTypeId: number;
  Description: string;
  IsComments: number;
  IsEnabled: number;
  lwfBusinessProcessModelId: number;
  IsOwnerSpecificQueue: number;
  wfBusinessProcessModel: string;
  wfBusinessProcessType: string;
  lwfBusinessProcessStateId: number;
  wfBusinessProcessState: string;
  lwfBusinessProcessRuleId: number;
  wfBusinessProcessRule: string;
  lwfBusinessProcessRuleActionId: number;
  wfBusinessProcessRuleAction: string;
  DisplayOrder: number;
  lwfBusinessProcessFromStateId: number;
  lwfBusinessProcessToStateId: number;
  sMessage: string;
  IsSkipMandatoryCheck: number;
  Condition: string;
  ActionType: string;
  IsSkipFieldEntryValidation: number;
  FieldEntryValidationCondition: string;
  IsRemainOpen: number;
  lwfBusinessProcessFunctionId: number;
  FunctionParameter: string;
  ExecutionOrder: number;
  OpenFormWebUrl: string;
  IsOpenOnNewTab: number;
  IsAsynchronousExecution: number;
  FromState: string;
  ToState: string;
  wfBusinessProcessFunction: string;
  DotNetAssembly: string;
  TypeName: string;
  ExecuteFunction: string;
  lwfBusinessProcessStateActionExecuteId: number;
}

export class BusinessProcessUserAction {
  lwfBusinessProcessInstanceId: number;
  lwfBusinessProcessStateId: number;
  swfBusinessProcessRuleAction: string;
  lwfBusinessProcessRuleActionId: number;
  sXMLProcessInstanceStateData: string;
  swfBusinessProcessInstanceComments: string;

}


export class JSONCurrentInstanceData {
  DataCaption: string;
  DataValue: string;
}

export class FileDetail {
  FileName: string;
  DataCaption: string;
  FileContent: any;
  lBusinessProcessInstanceCurrentStateDataId: string;
  FilePath: string;
}

export class BusinessProcessConfig {
  lBusinessProcessConfigId: number;

  FilePath: string;

  AllowedFileTypes: string;

  KAESCreditRequestBusinessProcessName: string;

}


export class SwitchPortal {
  lSwitchPortalId: number;
  UrlSilverLIght: string;
  UrlAngular: string;
  IsEnabled: string;
}


// Stateless workflow

export class BusinessProcessStateLessDefinitionDetail {
  lBusinessProcessStateLessDefinitionDetailId: string;
  lwfBusinessProcessStatelessDefinitionId: number;
  lwfBusinessProcessDefinitionId: number;
  Query: string;
  IsMDXQuery: number;
  ConnectionString: string;
  lwfBusinessProcessStatelessDefinitionDetailId: number;
  ColumnName: string;
  IsInput: number;
  lwfBusinessProcessStatelessInputTypeId: number;
  IsDisplay: number;
  DisplayOrder: number;
  DisplayArea: string;
  IsSummary: number;
  Width: number;
  ColumnHeader: string;
  OrderBy: number;
  FormatString: string;
  Parameters: string;
  wfBusinessProcessStatelessInputType: string;
  ItemSource: any;
  IsReadOnly: number;
  DataValue: any;
  MultiSelectedItems: any[];
  Opened: boolean;
  Min: number;
  Max: number;
  TextSize: number;
  Height: number;
  IsAddRowEnabled: number;
  DataTypeParameter: string;
}

export class BusinessProcessStateGridDataContext {
  RowNumber: number;
  RowStatus: string;
  DataValue: any;
  ItemSource: any;
  QueryResult: any;
  Actions: Action[];
  MultiSelectedItems: any[];
  Opened: boolean[];
  NumberFormat: string[];
  MinNum: number[];
  MaxNum: number[];
  TextSize: number[];
  IsStaticDataLoaded: boolean;
  BusinessProcessStateGridData: BusinessProcessStateGridData[];
}

export class BusinessProcessStateGridData {
  lwfBusinessProcessStateGridDataId: number;
  lwfBusinessProcessStateDataId: number;
  DataField: string;
  ColumnHeader: string;
  DataType: string;
  DataTypeParameter: string;
  DisplayOrder: number;
  ItemSource: any;
  IsEnabled: number;
  IsMandatory: number;
  IsReadOnly: number;
  IsOpenOnNewTab: number;
  IsVisible: number;
  Min: number;
  Max: number;
  TextSize: number;
  Height: number;
  FormatString: string;
  Width: number;
  DisplayArea: string;
  DataValue: any;
  MultiSelectedItems: any[];
  Opened: boolean;
}

export class BusinessProcessStateGridDataInstanceViewModel {
  DynamicInstanceDataSource: string;
}
export class BusinessProcessStateGridDataQueryResult {
  RowNumber: number;
  RowStatus: string;
  QueryResult: DynamicQueryResult[];
}

export class BusinessProcessStateDataGridUserAction {
  lwfBusinessProcessDefinitionId: number;
  lwfBusinessProcessStateDataGridActionId: number;
  sXMLProcessStateDataGrid: string;
}


export class BusinessProcessStateLessActionDetail {

  lBusinessProcessStateLessActionDetailId: string;
  lwfBusinessProcessStatelessDefinitionId: number;
  lwfBusinessProcessDefinitionId: number;
  Query: string;
  IsMDXQuery: number;
  ConnectionString: string;
  lwfBusinessProcessStatelessActionId: number;
  wfBusinessProcessStatelessAction: string;
  lwfBusinessProcessStatelessActionExecuteId: number;
  lwfBusinessProcessFunctionId: number;
  FunctionParameter: string;
  ExecutionOrder: number;
  OpenFormWebUrl: string;
  IsAsynchronousExecution: number;
  wfBusinessProcessFunction: string;
  IsCommonAction: number;
}


export class Action {
  ID: number;
  Name: string;
  Width: number;
}

export class BusinessProcessStatelessDataContext {
  RowNumber: number;
  DataValue: any;
  ItemSource: any;
  MultiSelectedItems: any[];
  QueryResult: any;
  Actions: Action[];
  BusinessProcessStateLessDefinitionDetails: BusinessProcessStateLessDefinitionDetail[];
  Opened: boolean[];
  NumberFormat: string[];
  MinNum: number[];
  MaxNum: number[];
  TextSize: number[];
  DataTypeParameter: string[];
  RowStatus: string;
  IsStaticDataLoaded: boolean;
  IsMultiSelectComboBox: boolean[];
}

export class BusinessProcessStatelessInstanceViewModel {
  DynamicInstanceDataSource: string;
  IsMDX: string;
  ColumnDetail: string;
}

export class DynamicQueryResult {
  ColumnName: string;
  DataValue: any;
  ColumnType: string;
}

export class BusinessProcessStatelessQueryResult {
  RowNumber: number;
  QueryResult: DynamicQueryResult[];
}

export class ItemSource {
  DisplayMember: string;
}

export class BusinessProcessStatelessUserAction {
  lwfBusinessProcessDefinitionId: number;
  lwfBusinessProcessStatelessActionId: number;
  sXMLProcessStatelessData: string;
}

export class BusinessProcessStatelessDependantDataItemSource {
  lwfBusinessProcessDefinitionId: number;
  sColumnName: string;
  sXMLProcessStatelessData: string;
}

export class BusinessProcessParam {
  lwfBusinessProcessInstanceId: number;
  sCurrentInstanceData: string;
  sRowXML: string;
  sDataCaption: string;
  lwfBusinessProcessStateDataId: number;
  lwfBusinessProcessRuleActionId: number;
  lwfBusinessProcessDefinitionId: number;
  sFilterValue: string;
}

export class StateGenericDataGridWidgetInstance {
  StateDataId: string;
  WidgetInstance: any;
}

export class StateDataGroup {
  GroupName: string;
  TabName: string;
}

export class ControlData {
  DataCaption: string;
  Control: any;
}

export class totalItems {
  column: string;
  summaryType: string;
  valueFormat: string;
  precision: string;
}

export class DocumentTemplate {
  lDocumentTemplateId: number;
  Name: string;
  Content: string;
  IsActive: number;
  ViewName: string;
  DocumentNamePrefix: string;
  DocumentNamePostfix: string;
  DocumentTag: string;
  DocumentTemplateDetail: DocumentTemplateDetail[];
}

export class DocumentTemplateDetail {
  lDocumentTemplateDetailId: number;
  lDocumentTemplateId: number;
  MappingColumnName: string;
  PlaceHolderName: string;
}

export class DocumentTemplateView {
  lDocumentTemplateId: number;
  Name: string;
  Content: string;
  lDocumentTemplateDetailId: number;
  MappingColumnName: string;
  PlaceHolderName: string;
  DocumentNamePrefix: string;
  DocumentNamePostfix: string;
  DocumentTag: string;
}
export class DocumentTemplateData {
  sDocumentTemplateIds: string;
  lwfBusinessProcessRuleActionId: number;
  lwfBusinessProcessStateDataGridActionId: number;
  sXMLStateData: string;
}
export class DocumentTemplateContent {
  Content: string;
  Filename: string;
  Title: string;
  IsHtml: boolean;
  FileName: string;
}
export class DocumentTemplateFunctionResult {
  sDocumentTemplateId: string;
  DocumentTemplateFunctionColumnDetails: DocumentTemplateFunctionColumnDetail[];
  DocumentTemplateFunctionColumns: string[];
}
export class DocumentTemplateFunctionColumnDetail {
  FunctionResults: { [key: string]: string };
}
export class FileContent {
  Content: string;
  Filename: string;
  FilePath: string;
  FileSystem: string;
  Directory: string;
  Title: string;
  IsHtml: boolean;
}
